export default {
  API_URL: 'https://api.acadatech.co.uk/development',
  UserPoolId: 'eu-west-2_Uj9IoD8ex',
  ClientId: 'u2tfs1r46rhcllf4pr8j9bo94',
  IdentityPoolId: 'eu-west-2:aaf3264f-9eab-4724-bbd5-9faff47b3aa3',
  GA: 'UA-134208651-2',
  name: 'dev',
  CognitoDomain: 'https://acada-dev.auth.eu-west-2.amazoncognito.com',
};
